const transfromRequiredRule = (passedRules) => {
  if (!passedRules) return passedRules;

  const { required, validate: passedValidateRule, ...restRules } = passedRules;

  if (!required) return passedRules;

  const requiredErrorMessage = typeof required === 'string' ? required : false;
  const requiredTrimmed = (value) => Boolean(value?.trim()) || requiredErrorMessage;

  if (!passedValidateRule) {
    return {
      ...restRules,
      validate: requiredTrimmed,
    };
  }

  if (typeof passedValidateRule === 'object') {
    return {
      ...restRules,
      validate: {
        ...passedValidateRule,
        requiredTrimmed,
      },
    };
  }

  return {
    ...restRules,
    validate: {
      custom: passedValidateRule,
      requiredTrimmed,
    },
  };
};

export default transfromRequiredRule;
